<template>
  <div class="mw7-ns center items-center pa3 mt5">
    <div v-if="loading">
      <pl-spinner style="margin: auto;" class="x2" />
    </div>
    <div v-else>
      <div class="center tc">
        <span class="tc summary-title"
          >Success! You have added / updated the following:</span
        >
      </div>
      <div
        v-if="users_tab === 'admin-add-users'"
        class="row col-xs center-xs no-margin pt4"
      >
        <div class="mr3">
          <div class="tc topics-data">{{ summary.teacher }}</div>
          <div class="tc topics-title">
            Teachers
          </div>
        </div>
        <div class="ml3">
          <div class="tc topics-data">{{ summary.student }}</div>
          <div class="tc topics-title">Students</div>
        </div>
        <div
          v-if="summary.users_not_added && summary.users_not_added.length"
          class="col-xs-12 center-xs mt4 fw5"
        >
          <div class="mb3">
            The following teachers were not added to the school because their
            accounts are already associated with a different school in Parlay.
          </div>
          <span
            v-for="(user, index) in summary.users_not_added"
            :key="index"
            class="b"
          >
            {{
              index + 1 !== summary.users_not_added.length
                ? user.email + ',&nbsp;'
                : user.email
            }}
          </span>
          <div class="mt3">
            If you have questions about this please click the chat bubble down
            below.
          </div>
        </div>
      </div>
      <div v-else class="row center-xs pt4">
        <div class="col-xs-12 topics-data">{{ summary.courses }}</div>
        <div class="col-xs-12 topics-title">
          Courses
        </div>
      </div>
      <div class="row center-xs pt4">
        <pl-button
          class="pl-primary"
          style="font-size: 16px; font-weight: 550;"
          @click.native="finish"
        >
          FINISH
        </pl-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        summary: {},
        loading: false,
      };
    },
    components: {},
    computed: {
      users_tab() {
        if (this.$route.name === 'admin-add-users') {
          return this.$route.name;
        }
        return 'admin-add-courses';
      },
    },
    methods: {
      finish() {
        if (this.users_tab === 'admin-add-users') {
          EventBus.$emit('updateUsersList');
          this.$store.dispatch('getSchoolDetails', this.$route.params.schoolID);
          this.$router.push({
            name: 'admin-users',
          });
        } else {
          EventBus.$emit('updateCoursesList');
          EventBus.$emit('showCoursesAddedModal');
          this.$router.push({
            name: 'admin-courses',
          });
        }
      },
    },
    created() {},
    mounted() {
      EventBus.$on('summaryUsersAdded', (summary) => (this.summary = summary));
      EventBus.$on(
        'summaryCoursesAdded',
        (summary) => (this.summary = summary)
      );
      EventBus.$on('loadingUsersOrCourses', (value) => (this.loading = value));
    },
    beforeDestroy() {
      EventBus.$off('summaryUsersAdded');
      EventBus.$off('summaryCoursesAdded');
      EventBus.$off('loadingUsersorCourses');
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .summary-title
    color: #273248
    font-size: 20px
    font-weight: 700
    text-align:center
  .topics-data
    color: #273248
    font-size: 52px
    font-weight: 600
  .topics-title
    color: #273248
    font-size: 22px
    font-weight: 500
    padding-top: 15px
</style>



// WEBPACK FOOTER //
// addUsersThirdStep.vue?431e3e2a